import {Box, Grid, Skeleton} from '@mui/material';
import {useEffect, useState} from 'react';
import {useMutation, useQueryClient} from 'react-query';
import {useDispatch} from 'react-redux';
import TemplateLoanCard from '../../../../../components/card/loanCard/TemplateLoanCard';
import ElementTitle from '../../../../../components/title/elementTitle/elementTitle';
import {IGetLoanTemplatesResponse} from '../../../../../models/loan.model';
import {GetLoanTemplates} from '../../../../../services/loan.service';
import {setHeaderTitle} from '../../../../../redux/headerTitle/headerTitleSlice';

const LoanTemplateList = ({
    setInnerState,
    setKey,
}: {
    setInnerState: any;
    setKey: any;
}) => {
    const [loanTemplates, setLoanTemplates] = useState<
        IGetLoanTemplatesResponse[]
    >([]);
    const queryClient = useQueryClient();
    const dispatch = useDispatch();

    const {mutate: GetLoanTemplatesMutate, isLoading} = useMutation(
        GetLoanTemplates,
        {
            onSuccess: (data: IGetLoanTemplatesResponse[]) => {
                if (data) {
                    setLoanTemplates(data);
                }
            },
            onError: () => {},
        }
    );

    const handleSelectTemplate = (key: string) => {
        setInnerState!('confirmLoanTemplate');
        setKey(key);
        queryClient.setQueryData('LOAN_TEMPLATE_KEY', key);
    };

    useEffect(() => {
        GetLoanTemplatesMutate({});
        dispatch(
            setHeaderTitle({
                header: 'انتخاب طرح تسهیلات',
                color: 'var(--header-color)',
                parentRoute: null,
            })
        );
    }, []);

    return (
        <div
            style={{
                height: '100svh',
                paddingInline: '20px',
                direction: 'ltr',
                overflowY: 'auto',
                paddingTop: '15px',
                paddingBottom: '60px',
            }}
        >
            <Box style={{overflowY: 'auto', direction: 'rtl'}}>
                {!isLoading ? (
                    <Box>
                        {loanTemplates.map((item, index) => (
                            <Grid
                                container
                                className="py-5"
                                style={{paddingTop: '0px'}}
                                key={index}
                            >
                                <Grid
                                    item
                                    xs={12}
                                    className="py-5"
                                    style={{paddingTop: '0px'}}
                                >
                                    <TemplateLoanCard
                                        title={item.title}
                                        description={item.description}
                                        logo={item.logoUrl}
                                        onClick={() =>
                                            handleSelectTemplate(item.key)
                                        }
                                    />
                                </Grid>
                            </Grid>
                        ))}
                    </Box>
                ) : (
                    <Box>
                        {[...Array(4)].map((_, index) => (
                            <Skeleton
                                key={index}
                                sx={{
                                    marginBottom: '20px',
                                    borderRadius: '10px',
                                    backgroundColor: 'lightgray',
                                }}
                                variant="rectangular"
                                height={100}
                                width={'100%'}
                            />
                        ))}
                    </Box>
                )}
            </Box>
        </div>
    );
};

export default LoanTemplateList;
